const BASE_URL = 'assets/logos'

export const Logos = {
  AppStore: `${BASE_URL}/app-store.png`,
  PlayStore: `${BASE_URL}/play-store.png`,
  AutoTrader: `${BASE_URL}/autotrader.png`,
  CedarsSinais: `${BASE_URL}/cedars-sinai.png`,
  ClutchAI: `${BASE_URL}/clutch_ai.png`,
  ClutchIOT: `${BASE_URL}/clutch_iot.png`,
  ClutchMachineLearning: `${BASE_URL}/clutch_machine_learning.png`,
  ClutchTopAppDev: `${BASE_URL}/clutch-top-app-dev.png`,
  ClutchTopUX: `${BASE_URL}/clutch-top-ux.png`,
  CodeleapLogoBlack: `${BASE_URL}/codeleap_logo_black.png`,
  CodeleapLogoWhite: `${BASE_URL}/codeleap_logo_white.png`,
  CodeleapLogoGray: `${BASE_URL}/codeleap_logo_gray.png`,
  CodeleapLogoGrayish: `${BASE_URL}/codeleap_logo_grayish.png`,
  Dealerships: `${BASE_URL}/dealerships.png`,
  Dexters: `${BASE_URL}/dexters.png`,
  DoverStreetMarket: `${BASE_URL}/dover-street-market.png`,
  EveningStandard: `${BASE_URL}/evening-standard.png`,
  Forbes: `${BASE_URL}/forbes.png`,
  Jet2Holidays: `${BASE_URL}/jet-2-holidays.png`,
  'aws-black-logo': `${BASE_URL}/aws-black-logo.png`,
  'aws-white-logo': `${BASE_URL}/aws-white-logo.png`,
  'aws-gray-logo': `${BASE_URL}/aws-gray-logo.png`,
  Lookers: `${BASE_URL}/lookers.png`,
  Marble: `${BASE_URL}/marble-logo.png`,
  MarieClaire: `${BASE_URL}/marie-claire.png`,
  Metro: `${BASE_URL}/metro.png`,
  PsychCentral: `${BASE_URL}/psych-central.png`,
  SweatyBetty: `${BASE_URL}/sweaty-betty.png`,
  USPainFoundation: `${BASE_URL}/us-pain-foundation.png`,
  WebMD: `${BASE_URL}/web-md.png`,
}
